import React, { useEffect, useState } from "react";
import CashierIcon from "../assets/svg/CashierIcon";
import GamesIcon from "../assets/svg/GamesIcon";
import HomeIcon from "../assets/svg/HomeIcon";
import SportsIcon from "../assets/svg/SportsIcon";
import Exchange from "../assets/images/Exchange.png";
import Whatsapp from "../assets/images/icons/whatsapp.png";
import Telegram from "../assets/images/icons/communication.png";
// import Facebook from "../assets/images/Facebook.svg";
import Instagram from "../assets/images/Instagram.svg";
import ProfileIcon from "../assets/svg/ProfileIcon";
import logo from "../assets/svg/logo_new.png";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { AiFillStar } from "react-icons/ai";
import { BsStarHalf } from "react-icons/bs";

import Visa from "../assets/images/providers/upi/visa.svg";
import Tether from "../assets/images/providers/upi/tether.svg";
import Bitcoin from "../assets/images/providers/upi/bitcoin.svg";
import Skrill from "../assets/images/providers/upi/skrill.svg";
import Astropay from "../assets/images/providers/upi/astropay.png";
import Phonepay from "../assets/images/providers/upi/phonepa.png";
import Netbank from "../assets/images/providers/upi/netbank.png";
import Gpay from "../assets/images/providers/upi/gpay.png";
import Mastercard from "../assets/images/providers/upi/mastercard.svg";
import Paytm from "../assets/images/providers/upi/paytm.png";
import rupay from "../assets/images/providers/upi/rupay.png";
import neteller from "../assets/images/providers/upi/neteller.png";

import faqIcon from "../assets/images/icons/question.png";
import Rightarrow from "../assets/images/icons/right-arrow-white.png";
import mobileIcon from "../assets/images/icons/mobile-phone.png";

import gcb from "../assets/images/icons/gcb.avif";
import pluseight from "../assets/images/icons/plus.png";
import SportsbookIcon from "../assets/images/icons/football.png";
import MenuIcon from "../assets/images/icons/more.png";
import CasinoIcon from "../assets/images/icons/seven.png";
import LiveIcon from "../assets/images/icons/playing-cards.png";
import CricketIcon from "../assets/images/icons/cricket.png";
import LogoWhite from "../assets/images/logo-white.png";
import LanguageChange from "../views/components/LanguageChange";

const BeforeLoginFooter = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { appDetails } = useSelector((state) => state.app);
  const [showToggle, setShowToggle] = useState(true);
  const isApk = localStorage.getItem("isApk") === "true";

  useEffect(() => {
    if (showToggle) {
      document.body.classList.add("active-mobile-menu");
    } else {
      document.body.classList.remove("active-mobile-menu");
    }
  }, [showToggle]);

  useEffect(() => {
    setShowToggle(window.screen.width > 991.98);
  }, []);

  return (
    <>
      <div className="container ContainerCss">
        <div className="upi-provider">
          <ul>
            <li>
              <a href="#">
                <img src={Visa} />
              </a>
            </li>
            <li>
              <a href="#">
                <img src={Tether} />
              </a>
            </li>
            <li>
              <a href="#">
                <img src={Paytm} />
              </a>
            </li>
            <li>
              <a href="#">
                <img src={rupay} />
              </a>
            </li>
            <li>
              <a href="#">
                <img src={neteller} />
              </a>
            </li>

            <li>
              <a href="#">
                <img src={Bitcoin} />
              </a>
            </li>

            <li>
              <a href="#">
                <img src={Skrill} />
              </a>
            </li>
            <li>
              <a href="#">
                <img src={Astropay} />
              </a>
            </li>
            <li>
              <a href="#">
                <img src={Phonepay} />
              </a>
            </li>
            <li>
              <a href="#">
                <img src={Netbank} />
              </a>
            </li>
            <li>
              <a href="#">
                <img src={Gpay} />
              </a>
            </li>
            <li>
              <a href="#">
                <img src={Mastercard} />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <footer className="footer">
        <div className="ContainerCss">
          <div className="footer-links d-md-flex d-none mb-5">
            <div className="footer-wrapper">
              <div>
                <div className="footer-logo">
                  {appDetails?.LOGO_URL && (
                    <img src={appDetails?.LOGO_URL || logo} />
                  )}
                </div>
              </div>
              <div className="d-flex gap-4 footeroption">
                <div className="betlinks">
                  <h4>Betheroz</h4>
                  <ul>
                    <li>
                      <a href="javascript:void(0)">Blog Betheroz</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">About Us</a>
                    </li>
                    <li>
                      <a href="/responsible-game">Responsible Gaming</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">Betheroz Affiliates</a>
                    </li>
                    <li>
                      <a href="/contact-us">Contact Us</a>
                    </li>
                  </ul>
                </div>
                <div className="betlinks">
                  <h4>Usage and Terms</h4>
                  <ul>
                    <li>
                      <a href="/termscondition">Terms and Conditions</a>
                    </li>
                    <li>
                      <a href="/home">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="/AMLpolicy">AML Policy</a>
                    </li>
                    <li>
                      <a href="/Bettingrules">Betting Rules</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="faq-app">
                <div className="">
                  <a href="">
                    <span>
                      <img src={faqIcon} /> FAQ
                    </span>{" "}
                    <img src={Rightarrow} />
                  </a>
                  {!isApk ? (
                    <a
                      href="https://dl.dropbox.com/scl/fi/1qh1sjdgcd3z31b2xqrns/BetHeroz.apk?rlkey=tm4ue65wgqr1p44y0oy85l3ep&st=tt9hip3o&dl=0"
                      download={
                        "https://dl.dropbox.com/scl/fi/1qh1sjdgcd3z31b2xqrns/BetHeroz.apk?rlkey=tm4ue65wgqr1p44y0oy85l3ep&st=tt9hip3o&dl=0"
                      }
                    >
                      <span>
                        <img src={mobileIcon} /> Mobile App
                      </span>{" "}
                      <img src={Rightarrow} />
                    </a>
                  ) : null}
                </div>
                <div className="secureGaming">
                  <ul>
                    <li>
                      <img src={gcb} />
                    </li>
                    <li>
                      <img src={pluseight} />
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="d-flex align-items-end">
              <div className="social-icons">
                <ul>
                  <li>
                    <a
                      href={
                        appDetails?.WHATS_APP_URL != ""
                          ? appDetails?.WHATS_APP_URL
                          : "javascript:void(0)"
                      }
                      target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                    >
                      {/* <span className="notification-count">2</span> */}
                      <img src={Whatsapp} alt="Whatsapp Icon" />
                    </a>
                  </li>
                  <li>
                    <a
                      href={
                        appDetails?.TELEGRAM != ""
                          ? appDetails?.TELEGRAM
                          : "javascript:void(0)"
                      }
                      target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                    >
                      <img src={Telegram} alt="Telegram Icon" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="d-md-none d-block mb-5">
            <div className="MobileFooter">
              <ul>
                <li>
                  <div className="footer-logo">
                    {appDetails?.LOGO_URL && (
                      // <img src={appDetails?.LOGO_URL || logo} alt="logo" />
                      <img src={LogoWhite} alt="logo" />
                    )}
                  </div>
                </li>

                <li>
                  <img src={gcb} />
                </li>
                <li>
                  <img src={pluseight} />
                </li>
              </ul>
            </div>
          </div>

          <p>{appDetails?.FOOTER_TEXT || ""}</p>

          <p className="copyright">
            Copyright © 2024 Betheroz. All Rights Reserved.
          </p>
        </div>

        <div className="footer-menu position-fixed start-0 bottom-0 z-index-2 w-100 d-block d-lg-none">
          <ul className="d-flex justify-content-evenly m-0 p-0 list-unstyled">
            <li>
              <a href="/atlas-lobby">
                <img src={SportsbookIcon} alt="" />
                <span>Sportsbook</span>
              </a>
            </li>
            <li>
              <a href="/atlas-lobby">
                <img src={CricketIcon} alt="" />
                <span>Cricket</span>
              </a>
            </li>
            <li>
              <a className="active" onClick={() => setShowToggle((s) => !s)}>
                <img src={MenuIcon} alt="" />
                <span>Home</span>
              </a>
            </li>
            <li>
              <a href="/cashier">
                <img src={CasinoIcon} alt="" />
                <span>Casino</span>
              </a>
            </li>
            <li>
              <a href="/casino" target="_blank">
                {/* <HeartIcon /> */}
                <img src={LiveIcon} alt="" />
                <span>Live Casino</span>
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </>
  );
};

export default BeforeLoginFooter;
